/**
 * 获取地址栏参数值
 * @param {*} name key
 * @return value
 */
export const getQueryString = (name) => {
    var after = window.location.hash.split("?")[1];
    if(after){
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = after.match(reg);
        if(r != null){
            return decodeURIComponent(r[2]);
        } else {
            return null;
        }
    }
    return null;
}